import { compose, withHandlers, withStateHandlers } from 'recompose';
import { Form } from 'antd';
import { connect } from 'react-redux';

import {
  getItemByPath,
} from '../../../utils';

import {
  handleTaskCreate,
  handleTaskUpdate,
} from '../../../redux/thunk/tasks';

import { TaskForm as Component } from './component';

const mapStateToProps = ({ users }, { request }) => {
  const requestAssignees = request.assignees
    ? request.assignees.map(assignee => getItemByPath(['items', assignee], users))
    : null;
  return { requestAssignees };
};

export const TaskForm = Form.create()(compose(
  connect(mapStateToProps, { handleTaskCreate, handleTaskUpdate }),
  withStateHandlers(
    ({ assignedTo }) => ({
      selectedUser: assignedTo,
    }),
    {
      setSelectedUser: () => value => ({
        selectedUser: value,
      }),
    },
  ),
  withHandlers({
    onSubmit: ({
      _id,
      form,
      request,
      onSubmit,
    }) => (event) => {
      event.preventDefault();
      form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          const data = {
            ...values,
            _id,
            requestId: request._id,
          };

          onSubmit(data);
        } else {
          console.error(err);
        }
      });
    },
  }),
)(Component));



// WEBPACK FOOTER //
// ./src/modals/add-meeting-notes-modal/task-form/container.js